/** Lets a screen ask the shell to draw the current route again after a change. */
let fn: () => void = () => {};
export const setRerender = (f: () => void) => {
  fn = f;
};
export const rerender = () => fn();
